import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import LiveTicker from '../components/LiveTicker';
import HeroSection from '../components/HeroSection';
import HotProperties from '../components/HotProperties';
import StarBonds from '../components/StarBonds';
import OpeningThisWeek from '../components/OpeningThisWeek';
import NewsBlog from '../components/NewsBlog';
import TopTraders from '../components/TopTraders';
import { securitiesAPI, leaderboardAPI, newsAPI } from '../services/api';

const Home = () => {
  const [movieStocks, setMovieStocks] = useState([]);
  const [starBonds, setStarBonds] = useState([]);
  const [hotSecurities, setHotSecurities] = useState([]);
  const [traders, setTraders] = useState([]);
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [moviesRes, starsRes, hotRes, tradersRes, newsRes] = await Promise.allSettled([
          securitiesAPI.getAll({ security_type: 'movie', limit: 8, sort_by: 'volume', order: 'desc' }),
          securitiesAPI.getAll({ security_type: 'star', limit: 6, sort_by: 'volume', order: 'desc' }),
          securitiesAPI.getHot(6),
          leaderboardAPI.get({ limit: 10 }),
          newsAPI.getAll({ limit: 6 }),
        ]);
        if (moviesRes.status === 'fulfilled') setMovieStocks(moviesRes.value.data?.securities || []);
        if (starsRes.status === 'fulfilled') setStarBonds(starsRes.value.data?.securities || []);
        if (hotRes.status === 'fulfilled') setHotSecurities(hotRes.value.data || []);
        if (tradersRes.status === 'fulfilled') setTraders(tradersRes.value.data || []);
        if (newsRes.status === 'fulfilled') setNews(newsRes.value.data?.articles || []);
      } catch {}
      setLoading(false);
    };
    fetchAll();
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0E17]" data-testid="home-page">
      <Header />
      <LiveTicker />
      <HeroSection />

      <HotProperties stocks={movieStocks} title="Hot MovieStocks" loading={loading} />

      <StarBonds stars={starBonds} loading={loading} />

      <section className="py-12 px-4">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <OpeningThisWeek movies={hotSecurities} loading={loading} />
          </div>
          <div>
            <TopTraders traders={traders} loading={loading} />
          </div>
        </div>
      </section>

      <NewsBlog news={news} loading={loading} />

      <Footer />
    </div>
  );
};

export default Home;
